import * as React from 'react'
import { useState } from 'react'
import { connect } from 'react-redux'
import { Stack, Box } from '@mui/material'
import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import { Grid, TableContainer, Table, TableHead, TableRow, TableCell, Paper, TableBody } from '@mui/material'
import Modal from '../../common/modal'
import '../../../App.css'
import '../../../css/modal.scss'
import LineInput from '../../common/lineinput'
import Datepicker from '../../common/datePicker'
import { Item } from '../../common/snippets'
import {
  Transfer_To_Branch,
  Transfer_Date,
  Driver_Name,
  Transfer_By_Vehicle,
  SOURCE_CITY_OP,
  DESTOINATION_CITY_OP,
  Transfer_From_Date,
  Transfer_To_Date,
} from './Lables'
import DropDownOA from '../../common/dropDownOA'
import {
  updateModal,
  getVehicleList,
  updateAlert,
  getBranchTransfer,
  getCancelTransferList,
  getCancelTransfer,
  getPrintMemo,
  getUpdateTransfer,
  getUpdateGetChallanNum,
  getBranchTransferV2,
} from '../../../store/common/common_action'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import EditIcon from '@mui/icons-material/Edit'
import { useEffect } from 'react'
import * as error from '../../common/error_strings'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import moment from 'moment'
import { callAddFontRobotoBold } from '../../common/font/Roboto-bold'
import { callAddFontRobotoNormal } from '../../common/font/Roboto-normal'
import { cityObj } from '../../common/constants'
import * as mdt from '../../common/modaltypes'
import ManageColumns from '../../common/ManageColumnsUI'
import { BrnhTransferColumnDefs } from './BrnhTransfConstant'
import { calculateDynamicFormatLandscape, calculateDynamicFormatPortrait, calculateTotalTableWidth, generateDynamicColumnStyles, focusElemnt, navigation3 } from '../../common/helper'
import { RAJESH_TRANSPORT, STA_COMPANY_ID } from '../../../helper/companyIdhardcode'
import { useAtom } from 'jotai'
import { companySettingsAtom } from '../../common/jotaiState/commonStateAtoms'
const BottomSection = ({
  getVehicleList,
  updateModal,
  updateAlert,
  getBranchTransfer,
  getBranchTransferV2,
  getCancelTransferList,
  getCancelTransfer,
  getPrintMemo,
  getUpdateTransfer,
  getUpdateGetChallanNum,
  data,
  selelectedData,
  allSelected,
  setAllState,
  allState,
  setSelectedData,
  setAllDataTopsection,
  cancelEdit,
  setCancelEdit,
  setCancelEditData,
  cancelEditData,
  handleAlert,
  inputCheck
}) => {
  const { common } = data
  const {
    brnchList,
    cityList,
    strtCity,
    loginData,
    strtBrnch,
    showModal,
    modalType,
    vehicleList,
    driverInfo,
    alert,
    branchTransfer,
    loader,
    brachTransferCancelList,
    cancelBranchTransfer,
    printMemo,
    updateTransfer,
    getChallanNumber,
    listData
  } = {
    ...common,
  }
  const [companySettings] = useAtom(companySettingsAtom)
  const { DefaultCurrencyID = 0 } = companySettings
  //All api data res store
  const [TransferBranchList, setTransferBranchList] = useState([])
  const [CancelTransferListData, setCancelTransferListData] = useState([])
  const [filtered, setFiltered] = useState([])
  const [searchStatus, setSearchStatus] = useState(false)
  const [apiData, setApiData] = useState({
    vehicleno: [],
    driverInformation: [],
    TransferBranchList: [],
    CancelTransferListData: [],
  })
  const { vehicleno, driverInformation } = apiData

  // All States Declare
  const [resetFlag, setResetFlag] = useState(false)
  const [allSelectedState, setAllSelectedState] = useState({
    transferToBranch: '',
    transferReason: '',
    remarks: '',
    transferByVehicle: '',
    selVehicleNo:'',
    selectedDriver: '',
    LrNo: [],
    BookingID: [],
    shortQtys: [],
    damageQtys: [],
    defaultValue: false,
    SourceCityOp: 'All',
    DestinationCityOp: 'All',
    cancelTransferList: false,
    selectedLrData: [],
    cancelBookingIds: [],
    cancelBranchTransferIDS: [],
    TableListData: null,
    challanNumber: '',
    imagee: '',
    load: false,
    generatePDF: false,
    cancelEditLrNo: '',
  })
  const {
    transferToBranch,
    defaultValue,
    transferByVehicle,
    selectedDriver,
    transferReason,
    remarks,
    LrNo,
    BookingID,
    shortQtys,
    damageQtys,
    SourceCityOp,
    DestinationCityOp,
    cancelTransferList,
    selectedLrData,
    cancelBookingIds,
    cancelBranchTransferIDS,
    TableListData,
    challanNumber,
    imagee,
    load,
    generatePDF,
    cancelEditLrNo,
  } = allSelectedState
  const [date, setDate] = useState({
    transferFromDate: null,
    transferToDate: null,
  })
  const [todayDate, setTodayDate] = useState(null)
  const [manageColumn, setManageColumn] = useState([])
  const { transferFromDate, transferToDate } = date
  const [successModal, setSuccessModal] = useState({
    CANCELTRANSFER: { id: 'CANCELTRANSFER', lrListLabel: 'cancel transfer popup modal', isSaved: false },
    SuccessTransfer: { id: 'SuccessTransfer', lrListLabel: 'cancel transfer popup modal', isSaved: false },
    SuccessTransferMessage: { id: 'SuccessTransferMessage', lrListLabel: 'cancel transfer popup modal', isSaved: false },
    CancelTransferMessage: { id: 'CancelTransferMessage', lrListLabel: 'for cancel transfer popup modal', isSaved: false },
    SuccessCancelTransferMessage: {
      id: 'SuccessCancelTransferMessage',
      lrListLabel: 'for Success cancel transfer popup modal',
      isSaved: false,
    },
    PrintMemo: { id: 'PrintMemo', lrListLabel: 'for Print Memo popup modal', isSaved: false },
    Print: { id: 'Print', lrListLabel: 'for Print popup modal', isSaved: false },
    LastTransferPrint: { id: 'LastTransferPrint', lrListLabel: 'successful transfer after', isSaved: false },
    UpdatePopUp: { id: 'UpdatePopUp', lrListLabel: 'for Update Transfer', isSaved: false },
    SuccessUpdatePopUp: { id: 'SuccessUpdatePopUp', lrListLabel: 'for success Update Transfer', isSaved: false },
  })
  // All States Declare End
  const printClick = () => {
    setAllSelectedState({ ...allSelectedState, load: true, generatePDF: true })

    jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
    jsPDF.API.events.push(['addFonts', callAddFontRobotoNormal])
    let FreightTotal = 0
    let CartageTotal = 0
    let HamaliTotal = 0
    let ValuationTotal = 0
    let othetrChargeTotal = 0
    let TotalTotal = 0
    let TotalGst = 0
    let Totalplusgst = 0
    printMemo?.Data?.Table.forEach((item, i) => {
      item.srNo = i + 1
      item.total = item.Freight + item.AllCartage + item.AllHamali + item.Valuation + item.OtherChg
      FreightTotal += item.Freight
      CartageTotal += item.AllCartage
      HamaliTotal += item.AllHamali
      ValuationTotal += item.Valuation
      othetrChargeTotal += item.OtherChg
      TotalTotal += item.total
      TotalGst += item.ServiceTaxAmount
      item.totalplusGST = item.total + item.ServiceTaxAmount
      Totalplusgst += item.totalplusGST
    })
    printMemo?.Data?.Table.push({
      srNo: 'Total',
      Freight: FreightTotal,
      AllCartage: CartageTotal,
      AllHamali: HamaliTotal,
      Valuation: ValuationTotal,
      OtherChg: othetrChargeTotal,
      total: TotalTotal,
      ServiceTaxAmount: TotalGst,
      totalplusGST: Totalplusgst,
    })
    const tableHeaderCol = manageColumn.filter((obj) => obj.isSelected && !obj.isSummaryHeader)
    const summaryHeaderCol = manageColumn.filter((obj) => obj.isSelected && obj.isSummaryHeader)
    if (DefaultCurrencyID === 2) {
      tableHeaderCol.forEach(col => {
        if (col.field === 'Valuation') {
          col.header = 'Insurance';
          col.exportHead = 'Insurance';
        }
      });
      summaryHeaderCol.forEach(col => {
        if (col.field === 'Valuation') {
          col.header = 'Total Insurance';
          col.exportHead = 'Total Insurance';
        }
      });
    }
    const HeaderColumn = [
      {
        headerName: 'Transfer By Branch',
        exportHead: 'Transfer By Branch:',
        field: 'BranchName',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Transfer To City',
        exportHead: 'Transfer To City',
        field: 'TransferToCity',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Transfer To Branch',
        exportHead: 'Transfer To Branch',
        field: 'ToBranchName',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Challan No',
        exportHead: 'Challan No',
        field: 'ChallanNo',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Vehicle No',
        exportHead: 'Vehicle No',
        field: 'VehicleNo',
        xlCol: { dataType: 'string', dataFormatter: null },
      }
    ]
    const HeaderColumn1 = [
      {
        headerName: 'Transfer By',
        exportHead: 'Transfer By',
        field: 'TransferBy',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Transfer Type',
        exportHead: 'Transfer Type',
        field: 'TransferType',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Transfer DateTime',
        exportHead: 'Transfer DateTime',
        field: 'TransferDateTime',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Generation Date and Time',
        exportHead: 'Generation Date and Time',
        field: 'GenerationDateandTime',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: '',
        exportHead: '',
        field: '',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
    ]
    const columnDefs = [
      {
        headerName: 'Sr. No.',
        exportHead: 'SR',
        field: 'srNo',
        xlCol: { dataType: 'number', dataFormatter: null, minCellWidth: 4 },
      },
      {
        headerName: 'Dest. City',
        exportHead: 'Dest. City',
        field: 'DestinationCity',
        xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 4 },
      },
      {
        headerName: 'Destination Branch',
        exportHead: 'Destination Branch',
        field: 'DestinationBranch',
        xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 4 },
      },
      {
        headerName: 'LR No.',
        exportHead: 'LR No.',
        field: 'LRNO',
        xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 4 },
      },
      {
        headerName: 'Send.Name',
        exportHead: 'Send.Name',
        field: 'Sender',
        xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 4 },
      },
      {
        headerName: 'Rec. Name',
        exportHead: 'Rec. Name',
        field: 'RecName',
        xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 4 },
      },
      // {
      //   headerName: 'Rec. MobNo',
      //   exportHead: 'Rec. MobNo',
      //   field: 'RecMobileNo',
      //   xlCol: { dataType: 'quantity', dataFormatter: null ,minCellWidth:4},
      // },
      {
        headerName: 'ItemType (Quantity)',
        exportHead: 'ItemType (Quantity)',
        field: 'ItemType',
        xlCol: { dataType: 'quantity', dataFormatter: null, minCellWidth: 4 },
      },
      {
        headerName: 'PayType',
        exportHead: 'PayType',
        field: 'PaymentType',
        xlCol: { dataType: 'quantity', dataFormatter: null, minCellWidth: 4 },
      },
      {
        headerName: 'Freight',
        exportHead: 'Freight',
        field: 'Freight',
        xlCol: { dataType: 'quantity', dataFormatter: null, minCellWidth: 4 },
      },
      {
        headerName: 'Cartage',
        exportHead: 'Cartage',
        field: 'AllCartage',
        xlCol: { dataType: 'quantity', dataFormatter: null, minCellWidth: 4 },
      },
      {
        headerName: 'Hamali',
        exportHead: 'Hamali',
        field: 'AllHamali',
        xlCol: { dataType: 'quantity', dataFormatter: null, minCellWidth: 4 },
      },
      {
        headerName: 'Valuation',
        exportHead: 'Valuation',
        field: 'Valuation',
        xlCol: { dataType: 'quantity', dataFormatter: null, minCellWidth: 4 },
      },
      {
        headerName: 'Other Charge',
        exportHead: 'Other Charge',
        field: 'OtherChg',
        xlCol: { dataType: 'quantity', dataFormatter: null, minCellWidth: 4 },
      },
      // {
      //   headerName: 'Total',
      //   exportHead: 'Total',
      //   field: 'total',
      //   xlCol: { dataType: 'quantity', dataFormatter: null ,minCellWidth:4},
      // },
      {
        headerName: 'GST',
        exportHead: 'GST',
        field: 'ServiceTaxAmount',
        xlCol: { dataType: 'quantity', dataFormatter: null, minCellWidth: 4 },
      },
      {
        headerName: 'AllTotal',
        exportHead: 'AllTotal',
        field: 'totalplusGST',
        xlCol: { dataType: 'quantity', dataFormatter: null, minCellWidth: 4 },
      },
      // {
      //   headerName: 'Description',
      //   exportHead: 'Description',
      //   field: 'Description',
      //   xlCol: { dataType: 'quantity', dataFormatter: null },
      // },
      {
        headerName: 'Comments',
        exportHead: 'Comments',
        field: 'Remarks',
        xlCol: { dataType: 'quantity', dataFormatter: null },
      },
    ]
    const secondColumn = [
      {
        headerName: 'Payment Type',
        exportHead: 'Payment Type',
        field: 'PaymentType',
        xlCol: { dataType: 'number', dataFormatter: null, },
      },
      {
        headerName: 'Total Freight',
        exportHead: 'Total Freight',
        field: 'Freight',
        xlCol: { dataType: 'string', dataFormatter: null, },
      },
      {
        headerName: 'Total Cartage	',
        exportHead: 'Total Cartage	',
        field: 'AllCartage',
        xlCol: { dataType: 'string', dataFormatter: null, },
      },
      {
        headerName: 'Total Hamali	',
        exportHead: 'Total Hamali	',
        field: 'AllHamali',
        xlCol: { dataType: 'string', dataFormatter: null, },
      },
      {
        headerName: 'Total Valuation',
        exportHead: 'Total Valuation',
        field: 'Valuation',
        xlCol: { dataType: 'quantity', dataFormatter: null, },
      },
      {
        headerName: '	Total Other Charges',
        exportHead: '	Total Other Charges',
        field: 'OtherChg',
        xlCol: { dataType: 'quantity', dataFormatter: null, },
      },
      {
        headerName: 'Total Amount	',
        exportHead: 'Total Amount	',
        field: 'total',
        xlCol: { dataType: 'quantity', dataFormatter: null, },
      },
      {
        headerName: 'Total GST',
        exportHead: 'Total GST',
        field: 'ServiceTaxAmount',
        xlCol: { dataType: 'quantity', dataFormatter: null, },
      },
      {
        headerName: 'Total+GST',
        exportHead: 'Total+GST',
        field: 'totalplusGST',
        xlCol: { dataType: 'quantity', dataFormatter: null, },
      },
    ]
    const HeaderData = [
      {
        BranchName: printMemo?.Data?.Table[0]?.BranchName,
        TransferToCity: printMemo?.Data?.Table[0]?.TransferToCity,
        ToBranchName: printMemo?.Data?.Table[0]?.ToBranchName,
        ChallanNo: challanNumber,
        VehicleNo: printMemo?.Data?.Table[0]?.VehicleNo,
        TransferBy: printMemo?.Data?.Table[0]?.TransferBy,
        TransferType: printMemo?.Data?.Table[0]?.TransferType,
        TransferDateTime: printMemo?.Data?.Table[0]?.TransferDateTime,
        GenerationDateandTime: moment(new Date()).format('DD MMM YYYY  LT'),
      },
    ]

    const result = []
    printMemo?.Data?.Table?.forEach(function (a) {
      if (!this[a.PaymentType]) {
        this[a.PaymentType] = {
          PaymentType: a.PaymentType,
          Freight: 0,
          AllCartage: 0,
          AllHamali: 0,
          Valuation: 0,
          OtherChg: 0,
          total: 0,
          ServiceTaxAmount: 0,
          totalplusGST: 0,
        }
        result.push(this[a.PaymentType])
      }
      this[a.PaymentType].Freight += a.Freight
      this[a.PaymentType].AllCartage += a.AllCartage
      this[a.PaymentType].AllHamali += a.AllHamali
      this[a.PaymentType].Valuation += a.Valuation
      this[a.PaymentType].OtherChg += a.OtherChg
      this[a.PaymentType].total += Number(a.total)
      this[a.PaymentType].ServiceTaxAmount += a.ServiceTaxAmount
      this[a.PaymentType].totalplusGST += a.totalplusGST
    }, Object.create(null))

    const HeaderColumns = HeaderColumn.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const HeaderColumns1 = HeaderColumn1.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const pdfColumns = tableHeaderCol.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const pdfColumns2 = summaryHeaderCol.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    let selectedFields = manageColumn.filter((item) => item.isSelected && !item.isSummaryHeader).reduce((result, item) => ({ ...result, [item.field]: true }), {})
    let summarySelectedFields = manageColumn.filter((item) => item.isSelected && item.isSummaryHeader).reduce((result, item) => ({ ...result, [item.field]: true }), {})
    const mainHeader = ['srNo', 'DestinationCity', 'DestinationBranch', 'LRNO', 'Sender', 'RecName', 'ItemType', 'PaymentType']
    const matchFields = Object.fromEntries(
      Object.entries(selectedFields).filter(([key]) => mainHeader.includes(key))
    );
    const widthCell = calculateTotalTableWidth(tableHeaderCol)
    const doc = new jsPDF({ orientation: tableHeaderCol.length > 12 ? 'l' : 'p', format: tableHeaderCol.length > 12 ? calculateDynamicFormatLandscape((widthCell > 1122 ? widthCell : 1122) + 60) : calculateDynamicFormatPortrait((widthCell > 900 ? widthCell : 900) + 60), unit: 'px', compress: true })
    doc.autoTableSetDefaults({
      headStyles: { fontSize: 6, width: 'auto', halign: 'left', fillColor: [30, 89, 167] },
    })
    var pageSize = doc.internal.pageSize
    var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
    var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()
    var scaleFactor = pageWidth / (tableHeaderCol.length > 12 ? 1122 : 793)
    var totalPagesExp = '{total_pages_count_string}'
    const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
      const doc = data.doc
      // Footer
      var str = 'Page : ' + doc.internal.getNumberOfPages()
      if (typeof doc.putTotalPages === 'function') {
        str = str + ' of ' + totalPagesExp
      }
      doc.setFontSize(scaleFactor * 14)
      doc.text(str, doc.internal.pageSize.width - data.settings.margin.left + 130, pageHeight - 5, "right")
      doc.setFont('Roboto', 'bold')
      doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
      doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize() / 2) + 90, pageHeight - 5)
    }

    let drawCell = function (data) {
      var rows = data.table.body
      if (data.row.section === 'head') {
        if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
          data.cell.styles.halign = "right";
        } else {
          data.cell.styles.halign = "left";
        }
      }
      rows.map((val) => {
        if (val.raw.srNo === 'Total') {
          let prevColSpan = 0;
          for (let key in val.raw) {
            if (key === 'srNo') {
              val.cells[prevColSpan].text = val.raw.srNo.toString();
              val.cells[prevColSpan].colSpan = Object.keys(matchFields).length
              val.cells[prevColSpan].styles.font = 'Roboto'
              val.cells[prevColSpan].styles.fontStyle = 'bold'
              val.cells[prevColSpan].styles.fontSize = scaleFactor * 12
              prevColSpan += Object.keys(matchFields).length
            } else {
              if (selectedFields.hasOwnProperty(key)) {
                val.cells[prevColSpan].styles.font = 'Roboto'
                val.cells[prevColSpan].styles.fontStyle = 'bold'
                val.cells[prevColSpan].styles.fontSize = scaleFactor * 12
                prevColSpan += 1;
              }
            }
          }

        }
      })
    }
    let drawCell2 = function (data) {
      var rows = data.table.body
      if (data.row.section === 'head') {
        if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
          data.cell.styles.halign = "right";
        } else {
          data.cell.styles.halign = "left";
        }
      }
      rows.map((val) => {
        if (val.raw.PaymentType == undefined) {
          let prevColSpan = 0;
          for (let key in val.raw) {
            if (key === 'PaymentType') {
              val.cells[prevColSpan].text = '';
              val.cells[prevColSpan].colSpan = 1
              val.cells[prevColSpan].styles.font = 'Roboto'
              val.cells[prevColSpan].styles.fontStyle = 'bold'
              val.cells[prevColSpan].styles.fontSize = scaleFactor * 12
              prevColSpan += 1
            } else {
              if (summarySelectedFields.hasOwnProperty(key)) {
                val.cells[prevColSpan].styles.font = 'Roboto'
                val.cells[prevColSpan].styles.fontStyle = 'bold'
                val.cells[prevColSpan].styles.fontSize = scaleFactor * 12
                prevColSpan += 1;
              }
            }
          }
        }
      })
    }
    doc.setProperties({
      title: `Transfer.pdf`,
      subject: 'Transfer Summary Report',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Transfer',
      creator: 'MTLPL',
    })
    let drawHeaderCell = function (data) {
      var rows = data.table.body
      if (data.row.section === 'head') {
        if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
          data.cell.styles.halign = "right";
        } else {
          data.cell.styles.halign = "left";
        }
      }
    }
    autoTable(doc, {
      margin: { top: 60, left: 30, right: 30, bottom: 5 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: HeaderColumns,
      body: HeaderData,
      startY: 100,
      columnStyles: {
        0: { halign: 'left', font: 'Roboto', cellPadding: 6, minCellHeight: 36, textColor: [0, 0, 0], minCellWidth: 200, valign: 'middle', fontStyle: "normal", fontSize: scaleFactor * 14 },
        1: { halign: 'left', font: 'Roboto', cellPadding: 6, minCellHeight: 36, textColor: [0, 0, 0], minCellWidth: 200, valign: 'middle', fontStyle: "normal", fontSize: scaleFactor * 14 },
        2: { halign: 'left', font: 'Roboto', cellPadding: 6, minCellHeight: 36, textColor: [0, 0, 0], minCellWidth: 200, valign: 'middle', fontStyle: "normal", fontSize: scaleFactor * 14 },
        3: { halign: 'left', font: 'Roboto', cellPadding: 6, minCellHeight: 36, textColor: [0, 0, 0], minCellWidth: 200, valign: 'middle', fontStyle: "normal", fontSize: scaleFactor * 14 },
        4: { halign: 'left', font: 'Roboto', cellPadding: 6, minCellHeight: 36, textColor: [0, 0, 0], minCellWidth: 200, valign: 'middle', fontStyle: "normal", fontSize: scaleFactor * 14 },
      },
      theme: 'grid',
      headStyles: {
        fillColor: [191, 225, 255],
        textColor: [0, 0, 0],
        minCellHeight: 36,
        valign: 'middle',
        cellPadding: 6,
        fontSize: scaleFactor * 14,
        fontStyle: 'normal',
        font: 'Roboto',
        lineWidth: 0.6,

      },
      didParseCell: (data) => {
        drawHeaderCell(data)
      },
    })
    autoTable(doc, {
      margin: { top: 60, left: 30, right: 30, bottom: 5 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: HeaderColumns1,
      body: HeaderData,
      startY: doc.lastAutoTable.finalY,
      columnStyles: {
        0: { halign: 'left', font: 'Roboto', cellPadding: 6, minCellHeight: 36, textColor: [0, 0, 0], minCellWidth: 200, valign: 'middle', fontStyle: "normal", fontSize: scaleFactor * 14 },
        1: { halign: 'left', font: 'Roboto', cellPadding: 6, minCellHeight: 36, textColor: [0, 0, 0], minCellWidth: 200, valign: 'middle', fontStyle: "normal", fontSize: scaleFactor * 14 },
        2: { halign: 'left', font: 'Roboto', cellPadding: 6, minCellHeight: 36, textColor: [0, 0, 0], minCellWidth: 200, valign: 'middle', fontStyle: "normal", fontSize: scaleFactor * 14 },
        3: { halign: 'left', font: 'Roboto', cellPadding: 6, minCellHeight: 36, textColor: [0, 0, 0], minCellWidth: 200, valign: 'middle', fontStyle: "normal", fontSize: scaleFactor * 14 },
        4: { halign: 'left', font: 'Roboto', cellPadding: 6, minCellHeight: 36, textColor: [0, 0, 0], minCellWidth: 200, valign: 'middle', fontStyle: "normal", fontSize: scaleFactor * 14 },
      },
      theme: 'grid',
      headStyles: {
        fillColor: [191, 225, 255],
        textColor: [0, 0, 0],
        minCellHeight: 36,
        valign: 'middle',
        cellPadding: 6,
        fontSize: scaleFactor * 14,
        fontStyle: 'normal',
        font: 'Roboto',
        lineWidth: 0.6,

      },
      didParseCell: (data) => {
        drawHeaderCell(data)
      },
    })
    autoTable(doc, {
      margin: { top: 100, left: 30, right: 30, bottom: 5 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      tableLineWidth: 0.6,
      bodyStyles: {
        lineWidth: [0, 0.6, 0, 0.6]
      },
      columns: pdfColumns,
      body: printMemo?.Data?.Table,
      columnStyles: generateDynamicColumnStyles(tableHeaderCol, scaleFactor * 12),
      theme: 'grid',
      headStyles: {
        fillColor: [191, 225, 255],
        textColor: [0, 0, 0],
        minCellHeight: 36,
        valign: 'middle',
        cellPadding: 6,
        fontSize: scaleFactor * 12,
        fontStyle: 'normal',
        font: 'Roboto',
      },
      didParseCell: (data) => {
        drawCell(data)
      },
      willDrawCell: (data) => {
        if (data.row.raw.srNo === 'Total') {
          doc.setFillColor(238, 238, 238);
          doc.setTextColor(0, 0, 0);
          data.cell.styles.valign = 'middle';
          doc.setFontSize(scaleFactor * 12).setFont("Roboto", 'bold')
        }
      },
    })
    doc.setFont('Roboto')
    autoTable(doc, {
      margin: { top: 60, left: 30, right: 30, bottom: 5 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      tableLineWidth: 0.6,
      bodyStyles: {
        lineWidth: [0, 0.6, 0, 0.6]
      },
      columns: pdfColumns2,
      body: result,
      columnStyles: generateDynamicColumnStyles(summaryHeaderCol, scaleFactor * 12),
      theme: 'grid',
      headStyles: {
        fillColor: [191, 225, 255],
        textColor: [0, 0, 0],
        minCellHeight: 36,
        valign: 'middle',
        cellPadding: 6,
        fontSize: scaleFactor * 12,
        fontStyle: 'normal',
        font: 'Roboto',
      },
      didParseCell: (data) => {
        drawCell2(data)
      },
      willDrawCell: (data) => {
        if (data.row.raw.PaymentType == undefined) {
          doc.setFillColor(238, 238, 238);
          doc.setTextColor(0, 0, 0);
          data.cell.styles.valign = 'middle';
          doc.setFontSize(scaleFactor * 12).setFont("Roboto", 'bold')
        }
      },
      didDrawPage: function (data) {
        doc.setTextColor(scaleFactor * 40)
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 30, 50, 50)
        doc.setFontSize(scaleFactor * 20)
        doc.setTextColor(16, 79, 162)
        doc.text('Cargo System | Branch Transfer Report', 30 + 60, 60)
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(scaleFactor * 20).setFont("Roboto", 'bold')
        doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 60, "right")
        jsPdfHeaderFooter(data, loginData, totalPagesExp)
      },
    })
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    try {
      setTimeout(() => {
        setAllSelectedState({ ...allSelectedState, generatePDF: false })
        document.getElementById('output').data = doc.output('datauristring', 'printMemo.pdf')
      }, 2000)
    } catch (error) {
      console.log(error)
    }
    try {
      setTimeout(() => {
        setAllSelectedState({ ...allSelectedState, load: true })
        document.getElementById('output2').data = doc.output('datauristring', 'print.pdf')
      }, 2000)
    } catch (error) {
      console.log(error)
    }
    try {

      setTimeout(() => {
        setAllSelectedState({ ...allSelectedState, load: true })
        document.getElementById('output3').data = doc.output('datauristring', 'print.pdf')
      }, 2000)
    } catch (error) {
      console.log(error)
    }
   
   
  }

  //get numeric months
  function getNumericMonth(monthAbbr) {
    return String(['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'].indexOf(monthAbbr) + 1).padStart(
      2,
      '0'
    )
  }

  function dateFormat(date) {
    const day = date.toString().split('-')[0]
    const month = getNumericMonth(date.toString().split('-')[1])
    const year = date.toString().split('-')[2]
    return `${day}-${month}-${year}`
  }
  useEffect(() => {
    if (updateTransfer.status == 'Success') {
      updateModal(true, 'SuccessUpdatePopUp')
      setCancelEdit(false)
      setAllState({ ...allState, showListTable: false, showListAllTable: false, defaultValueForTop: true })
      setAllSelectedState({
        ...allSelectedState,
        defaultValue: true,
        transferReason: '',
        remarks: '',
        transferToBranch: '',
        transferByVehicle: '',
        selectedDriver: '',
        LrNo: [],
        BookingID: [],
        shortQtys: [],
        damageQtys: [],
      })
      setSelectedData([])
      setAllDataTopsection({
        ...allSelected,
        selectDestCity: 'All',
        selectDestBranch: 'All',
        selectBookingtype: 'All',
        selectconsignmentType: 'All',
        selectedButtonType: 'Booking',
      })
      setResetFlag(!resetFlag)
    }
  }, [updateTransfer])

  useEffect(() => {
    const todayDate = new Date().toString().split(' ')
    const year = todayDate[3]
    const day = todayDate[2]
    const month = getNumericMonth(todayDate[1])
    const currentDate = `${year}-${month}-${day}`
    const today = `${day}-${month}-${year}`
    setAllSelectedState({ ...allSelectedState, defaultValue: false })
    setTodayDate(today)
    setDate({ ...date, transferFromDate: currentDate, transferToDate: currentDate })
  }, [])

  useEffect(() => {
    if (brachTransferCancelList?.Table?.length >= 1) {
      const arry = brachTransferCancelList?.Table?.map((val) => ({ ...val, checked: false }))
      setCancelTransferListData(arry)
      // setApiData({ ...apiData, CancelTransferListData: arry })
      setAllSelectedState({ ...allSelectedState, TableListData: false })
    } else {
      setCancelTransferListData([])
      setAllSelectedState({ ...allSelectedState, TableListData: true, cancelTransferList: false })
    }
  }, [brachTransferCancelList])

  // All UseEffects

  useEffect(() => {
    if (printMemo.status === 'Success') {
      printClick()
    }
  }, [printMemo])

  useEffect(() => {
    const TransferBranchListt = brnchList.filter(
      ({ BranchID, BranchName, BranchTypeID, CityID, CargoHasBranchReceive, IsCargoGodownBranch }) => strtBrnch?.BranchID != BranchID && (BranchTypeID == 2 || BranchTypeID == 3) && (BranchID !== 36462 || BranchID !== 36514 || BranchID !== 42438)
        && strtBrnch?.CityID === CityID && (CargoHasBranchReceive === 1 || IsCargoGodownBranch === 1)
    )
    setTransferBranchList(TransferBranchListt)
    // setApiData({ ...apiData, TransferBranchList:[] })
    // setApiData({ ...apiData, TransferBranchList: TransferBranchListt, vehicleno: vehicleList, driverInformation: driverInfo })
  }, [brnchList, strtBrnch, cancelBranchTransfer])
  useEffect(() => {
    if (selelectedData?.length >= 1) {
      const lr = selelectedData?.map((item) => item?.LRNO)
      const bookingid = selelectedData?.map((item) => item?.BookingID)
      const ShortQtys = selelectedData?.map((item) => 0)
      const DamageQtys = selelectedData?.map((item) => 0)
      setAllSelectedState({ ...allSelectedState, LrNo: lr, BookingID: bookingid, shortQtys: ShortQtys, damageQtys: DamageQtys })
    } else {
      setAllSelectedState({ ...allSelectedState, LrNo: [], BookingID: [], shortQtys: [], damageQtys: [] })
    }
  }, [selelectedData])
  useEffect(() => {
    if (selectedLrData?.length >= 1) {
      const bookingid = selectedLrData.map((item) => item.BookingID)
      const BranchTransferIDS = selectedLrData.map((item) => item.BranchTransferDetID)
      setAllSelectedState({ ...allSelectedState, cancelBookingIds: bookingid, cancelBranchTransferIDS: BranchTransferIDS })
    } else {
      setAllSelectedState({ ...allSelectedState, cancelBookingIds: [], cancelBranchTransferIDS: [] })
    }
  }, [selectedLrData])
  // useEffect(() => {
  //   if (loginData) {
  //     getVehicleList(loginData)
  //   }
  // }, [loginData])
  useEffect(() => {
    if (branchTransfer.status == true) {
      updateModal(true, 'SuccessTransferMessage')
      const obj = {
        Data: branchTransfer.Data,
        status: true,
      }
      getUpdateGetChallanNum(obj)
      setAllState({ ...allState, showListTable: false, showListAllTable: false, defaultValueForTop: true })
      setAllSelectedState({
        ...allSelectedState,
        defaultValue: true,
        transferReason: '',
        remarks: '',
        transferToBranch: '',
        transferByVehicle: '',
        selectedDriver: '',
        LrNo: [],
        BookingID: [],
        shortQtys: [],
        damageQtys: [],
      })
      setSelectedData([])
      setAllDataTopsection({
        ...allSelected,
        selectDestCity: 'All',
        selectDestBranch: 'All',
        selectBookingtype: 'All',
        selectconsignmentType: 'All',
        selectedButtonType: 'Booking',
      })
      setResetFlag(!resetFlag)
    } else {
      handleAlert(branchTransfer.Message)
    }
  }, [branchTransfer])
  useEffect(() => {
    if (cancelBranchTransfer.status == true) {
      setAllSelectedState({ ...allSelectedState, selectedLrData: [] })
      setCancelTransferListData([])
      // setApiData({ ...apiData, CancelTransferListData: [] })
      updateModal(true, 'SuccessCancelTransferMessage')
    }
  }, [cancelBranchTransfer])
  useEffect(() => {
    const getLocalData = (key) => {
      return new Promise((resolve) => {
        const localData = localStorage.getItem(key)
        resolve(localData ? JSON.parse(localData) : null)
      })
    }
    const updateColumnDetails = async () => {
      try {
        const localDispatchCol = await getLocalData('BrnhTransferMemoManageCol1');
        let cols = localDispatchCol || BrnhTransferColumnDefs
        if (DefaultCurrencyID === 2) {
          cols = cols.map(col => {
            if (col.field === 'Valuation') {
              return {
                ...col,
                header: col.isSummaryHeader ? 'Total Insurance' : 'Insurance',
                exportHead: col.isSummaryHeader ? 'Total Insurance' : 'Insurance'
              };
            }
            return col;
          });
        }
        setManageColumn(cols);
      } catch (error) {
        console.error(error);
        setManageColumn(BrnhTransferColumnDefs);
      }
    };
    updateColumnDetails()
  }, [DefaultCurrencyID])

  let repeatdata = [
    { id: 0, name: 'contains', colName: 'IsReceived' },
    { id: 1, name: 'contains', colName: 'LRNO' },
    { id: 2, name: 'contains', colName: 'BookingDateTime' },
    { id: 3, name: 'contains', colName: 'TransferDateTime' },
    { id: 4, name: 'contains', colName: 'Sender' },
    { id: 5, name: 'contains', colName: 'RecName' },
    { id: 6, name: 'contains', colName: 'FromCity' },
    { id: 7, name: 'contains', colName: 'ToCity' },
    { id: 8, name: 'contains', colName: 'TransferedTo' },
    { id: 9, name: 'contains', colName: 'VehicleNo' },
  ]
  const handleChangeContain = (id, name) => {
    var userInput = document.getElementsByName('cancelSearchInput')[id].value
    var count = 0
    const lData = []
    const data = CancelTransferListData
    if (userInput !== '') {
      var regex = new RegExp(userInput.trim().replace(/\\/g, "\\\\"), 'i')
      {
        data.map((val) => {
          if ((val[name] != null ? val[name].toString() : '').search(regex) !== -1) {
            const x = {
              BookingDateTime: val.BookingDateTime,
              BookingID: val.BookingID,
              BranchTransferDetID: val.BranchTransferDetID,
              FromCity: val.FromCity,
              IsReceived: val.IsReceived,
              LRNO: val.LRNO,
              NetAmount: val.NetAmount,
              RecName: val.RecName,
              Select: val.Select,
              Sender: val.Sender,
              ToCity: val.ToCity,
              TransferDateTime: val.TransferDateTime,
              TransferedTo: val.TransferedTo,
              VehicleNo: val.VehicleNo,
              checked: val.checked,
            }
            lData.push(x)
            count++
          }
        })
      }
      setFiltered(lData)
      setSearchStatus(true)
    } else {
      setFiltered([])
      setSearchStatus(false)
    }
  }
  // for show error
  // const handleAlert = (msg = false) => {
  //   if (!(msg instanceof Event)) {
  //     if (msg) {
  //       updateAlert({ show: true, msg })
  //     } else {
  //       updateAlert({ show: false, msg: '' })
  //     }
  //   }
  // }
  const onKeyDown = (id, e) => {
    switch (id) {
      case 'TransferReason':
        if (e.key === 'Enter') {
          document.getElementById('selectTV').focus()
        } else if (e.key === 'Escape') {
          document.getElementById('TrToBranch').focus()
        }
        break
      case 'remarks':
        if (e.key === 'Enter') {
          document.getElementById('Transferbtn').focus()
        } else if (e.key === 'Escape') {
          document.getElementById('selectDN').focus()
        }
        break
      default:
        break
    }
  }
  //for All Onclick
  const onClick = (id, item) => {
    switch (id) {
      case 'CANCELTRANSFER':
        updateModal(true, 'CANCELTRANSFER')
        const todayDate = new Date().toString().split(' ')
        const year = todayDate[3]
        const day = todayDate[2]
        const month = getNumericMonth(todayDate[1])
        const currentDate = `${year}-${month}-${day}`
        setDate({ ...date, transferFromDate: currentDate, transferToDate: currentDate })
        setAllSelectedState({
          ...allSelectedState,
          TableListData: null,
          SourceCityOp: 'All',
          DestinationCityOp: 'All',
          cancelTransferList: false,
        })
        break
      case 'CANCELTRANSFERCLOSE':
        updateModal(false, 'CANCELTRANSFER')
        break
      case 'Transfer':
        if (selelectedData.length < 1) {
          handleAlert(error.SELECT_LR)
        } else if (transferToBranch === '') {
          handleAlert(error.TRANSFER_TO_BRANCH)
        } else if (transferByVehicle === '') {
          handleAlert(error.TRANSFER_BY_VEHICLE)
        } else {
          setAllSelectedState({ ...allSelectedState, load: false })
          updateModal(true, 'SuccessTransfer')
        }
        break
      case 'confirmTransfer':
        setAllSelectedState({ ...allSelectedState, load: false })
        const LRno = LrNo.join('^').toString()
        const bookingid = BookingID.join('^').toString()
        const shortQtyss = shortQtys.join('^').toString()
        const DamageQtys = damageQtys.join('^').toString()
        if (inputCheck) {
          let bkgID = selelectedData.map(({ BookingID }) => BookingID)
          const body = {
            CurrentCityID: strtCity?.CityID,
            CurrentBranchID: strtBrnch.BranchID,
            UserID: loginData.intUserID,
            ToBranchID: allSelected.selectDestBranch === 'All' || allSelected.selectDestBranch === undefined ? 0 : allSelected.selectDestBranch?.BranchID,
            ToCityID: allSelected.selectDestCity === 'All' || allSelected.selectDestCity === undefined ? 0 : allSelected.selectDestCity?.CityID,
            CompanyID: loginData.intCompanyID,
            ConsignmentSubTypeID: allSelected.selectconsignmentType === 'All' || allSelected.selectconsignmentType === undefined ? 0 : allSelected.selectconsignmentType?.ConsignmentSubTypeID,
            PaymentTypeID: allSelected.selectBookingtype === 'All' || allSelected.selectBookingtype === undefined ? 0 : allSelected.selectBookingtype?.typeId,
            IsBookingTransfer: allSelected?.selectedButtonType === 'Delivery' ? 0 : 1,
            VehicleType: 'SV',
            VehicleNo: transferByVehicle.VehicleNo,
            Remarks: remarks,
            TransferReason: transferReason,
            VehicleID: transferByVehicle.VehicleID,
            DriverID: selectedDriver.DriverConductorID,
            intBTFromCityID: strtCity?.CityID,
            intBTToCityID: transferToBranch?.CityID,
            intBTFromBranchID: strtBrnch.BranchID,
            intBTToBranchID: transferToBranch?.BranchID,
            IsBranchTransferAllLrs: listData?.Table?.length === selelectedData?.length ? 1 : 0,
            ExceptionBookingIDs: listData?.Table?.filter((item) => !bkgID?.includes(item.BookingID))
              ?.map((obj) => obj?.BookingID)
              ?.join('^'),
          }
          getBranchTransferV2(body)
        } else {
          const data = {
            intBranchTransferID: 0,
            intFromCityID: strtCity?.CityID,
            intToCityID: strtCity?.CityID,
            intFromBranchID: strtBrnch.BranchID,
            intToBranchID: transferToBranch?.BranchID,
            strVehicleType: 'SV',
            strVehicleNo: transferByVehicle.VehicleNo,
            strTransferReason: transferReason,
            strRemarks: remarks,
            blnDeliveryTransfer: allSelected.selectedButtonType === 'Booking' ? 0 : 1,
            intVehicleID: transferByVehicle.VehicleID,
            strBookingIDs: bookingid,
            strLRNos: LRno,
            strShortQtys: shortQtyss,
            strDamageQtys: DamageQtys,
            intDriverID: selectedDriver.DriverConductorID,
          }
          getBranchTransfer(loginData, data)
        }
        updateModal(false, 'SuccessTransfer')

        break
      case 'CLosePopupTransfer':
        updateModal(false, 'SuccessTransfer')
        break
      case 'successfullTransfer':
        const todayDate2 = new Date().toString().split(' ')
        const year2 = todayDate2[3]
        const day2 = todayDate2[2]
        const month2 = getNumericMonth(todayDate2[1])
        const currentDate2 = `${year2}-${month2}-${day2}`
        setAllSelectedState({ ...allSelectedState, challanNumber: branchTransfer.Data })
        const printObj = {
          intFromCityID: strtCity?.CityID,
          intFromBranchID: strtBrnch?.BranchID,
          intChallanNo: Number(branchTransfer.Data),
          date: currentDate2,
          vehicleNo:allSelectedState?.selVehicleNo?.VehicleNo || ''
        }
        getPrintMemo(loginData, printObj)
        document.getElementById('selectDC').focus()
        break
      case 'successfullTransferclose':
        updateModal(false, 'SuccessTransferMessage')
        document.getElementById('selectDC').focus()
        break
      case 'cancelGenerate':
        const cancelListData = {
          FromCityID: strtCity?.CityID,
          FromBranchID: strtBrnch?.BranchID,
          ToCityID: 0,
          FromDate: transferFromDate,
          ToDate: transferToDate,
          SourceCityID: SourceCityOp === 'All' ? 0 : SourceCityOp?.CityID,
          DestinationCityID: DestinationCityOp === 'All' ? 0 : DestinationCityOp?.CityID,
        }
        getCancelTransferList(loginData, cancelListData)
        setAllSelectedState({ ...allSelectedState, cancelTransferList: true })
        break
      case 'CancelTransferPopup':
        if (selectedLrData.length < 1) {
          handleAlert(error.SELECT_LR)
        } else {
          updateModal(true, 'CancelTransferMessage')
        }
        break
      case 'cancelTransfer':
        const cancelBookingid = cancelBookingIds.join('^').toString()
        const cancelBranchIds = cancelBranchTransferIDS.join('^').toString()
        updateModal(false, 'CancelTransferMessage')

        const Canceldata = {
          strBookingIDs: cancelBookingid,
          strBranchTransferIDS: cancelBranchIds,
        }
        getCancelTransfer(loginData, Canceldata)
        break
      case 'closeCancelTransfer':
        updateModal(false, 'CancelTransferMessage')
        break
      case 'successfullTransferCancel':
        updateModal(false, 'SuccessCancelTransferMessage')
        document.getElementById('selectDC').focus()
        break
      case 'successfullTransferCancelclose':
        updateModal(false, 'SuccessCancelTransferMessage')
        document.getElementById('selectDC').focus()
        break
      case 'printMemoPopUp':
        setAllSelectedState({ ...allSelectedState, load: false, challanNumber: '' })
        updateModal(true, 'PrintMemo')
        break
      case 'printMemo':
        if (challanNumber === '') {
          handleAlert(error.ENTER_CHALLAN_NUMBER)
        } else {
          setAllSelectedState({ ...allSelectedState, load: true })
          const todayDate = new Date().toString().split(' ')
          const year = todayDate[3]
          const day = todayDate[2]
          const month = getNumericMonth(todayDate[1])
          const currentDate = `${year}-${month}-${day}`
          const printObj = {
            intFromCityID: strtCity?.CityID,
            intFromBranchID: strtBrnch?.BranchID,
            intChallanNo: Number(challanNumber),
            date: currentDate,
          }
          getPrintMemo(loginData, printObj, updateModal)
          // printClick()
        }
        break
      case 'LastTransferPrintBTN':
        setAllSelectedState({ ...allSelectedState, load: false })
        updateModal(true, 'LastTransferPrint')
        break
      case 'LastTransferPrint':
        if (getChallanNumber?.status == true) {
          const todayDate3 = new Date().toString().split(' ')
          const year3 = todayDate3[3]
          const day3 = todayDate3[2]
          const month3 = getNumericMonth(todayDate3[1])
          const currentDate3 = `${year3}-${month3}-${day3}`
          setAllSelectedState({ ...allSelectedState, challanNumber: branchTransfer.Data })
          const printObj3 = {
            intFromCityID: strtCity?.CityID,
            intFromBranchID: strtBrnch?.BranchID,
            intChallanNo: Number(getChallanNumber?.Data),
            date: currentDate3,
          }

          getPrintMemo(loginData, printObj3)
        } else {
          updateModal(false, 'LastReceivePrint')
          handleAlert('No Transfer Found')
        }
        break
      case 'LastTransferPrintClose':
        updateModal(false, 'LastTransferPrint')
        break
      case 'cancelEdit':
        setAllSelectedState({ ...allSelectedState, cancelEditLrNo: item.LRNO })
        setCancelEditData(item)
        setAllState({ ...allState, showListTable: true, showListAllTable: true })
        setCancelEdit(true)
        updateModal(false, 'CANCELTRANSFER')
        break
      case 'UpdateTransferModal':
        if (transferToBranch === '') {
          handleAlert(error.TRANSFER_TO_BRANCH)
        } else {
          updateModal(true, 'UpdatePopUp')
        }
        break
      case 'UpdateTransfer':
        const obj = {
          intBranchTransferDetID: cancelEditData.BranchTransferDetID,
          intToBranchID: transferToBranch?.BranchID,
          strVehicleNo: transferByVehicle.VehicleNo,
          strTransferReason: transferReason,
          strRemarks: remarks,
          intVehicleID: transferByVehicle.VehicleID,
          intDriverID: selectedDriver.DriverConductorID,
          intToCityID: strtCity?.CityID,
          intCompanyID: loginData.intCompanyID,
          strVehicleType: 'SV',
          intUserID: loginData.intUserID,
          blnDeliveryTransfer: 0,
        }

        getUpdateTransfer(obj)
        updateModal(false, 'UpdatePopUp')

        break
      case 'closeUpdateTransfer':
        updateModal(false, 'UpdatePopUp')
        break
      case 'successfullTransferUpdate':
        updateModal(false, 'SuccessUpdatePopUp')
        break
      default:
        break
    }
  }
  //All handle Change
  const handleChange = (e, id) => {
    switch (id) {
      case 'TransferReason':
        setAllSelectedState({ ...allSelectedState, transferReason: e.target.value })
        break
      case 'remark':
        setAllSelectedState({ ...allSelectedState, remarks: e.target.value })
        break
      case 'transferfromdate':
        const Fromdate = e?._d?.toString()?.split(' ')
        const fromyear = Fromdate?.[3]
        const fromday = Fromdate?.[2]
        const frommonth = getNumericMonth(e?._d?.toString()?.split(' ')?.[1])
        const fromcurrentDate = `${fromyear}-${frommonth}-${fromday}`
        setDate({ ...date, transferFromDate: fromcurrentDate })
        break
      case 'transferTodate':
        const Todate = e?._d?.toString()?.split(' ')
        const year = Todate?.[3]
        const day = Todate?.[2]
        const month = getNumericMonth(e?._d?.toString()?.split(' ')?.[1])
        const currentDate = `${year}-${month}-${day}`
        setDate({ ...date, transferToDate: currentDate })

        break
      case 'cancelListData':
        const { checked, id } = e.target
        if (checked) {
          const data = CancelTransferListData.map((val) => {
            if (val.BookingID === Number(id)) {
              val.checked = true
            }
            return val
          })
          setCancelTransferListData(data)
          // setApiData({ ...allSelectedState, CancelTransferListData: data })
          const selecteddata = CancelTransferListData?.filter((val) => val.BookingID == Number(e.target.id))
          const selectedObject = [...selectedLrData, selecteddata[0]]
          setAllSelectedState({ ...allSelectedState, selectedLrData: selectedObject })
        } else {
          const data = CancelTransferListData.map((val) => {
            if (val.BookingID === Number(id)) {
              val.checked = false
            }
            return val
          })
          setCancelTransferListData(data)
          // setApiData({ ...allSelectedState, CancelTransferListData: data })
          const selecteddata = selectedLrData.filter((item) => item.BookingID !== Number(id))
          setAllSelectedState({ ...allSelectedState, selectedLrData: selecteddata })
        }
        break
      case 'challanNO':
        setAllSelectedState({ ...allSelectedState, challanNumber: e.target.value })
        break
      default:
        break
    }
  }
  const handleKeyDownConfirm = (e, id) => {
    if (e.keyCode === 37) {
      if (id == "transferConfirmNo") {
        focusElemnt("transferConfirmYes")
      } else if (id == "transferConfirmYes") {
        focusElemnt("transferConfirmNo")
      }
    } else if (e.keyCode == 39) {
      if (id == "transferConfirmNo") {
        focusElemnt("transferConfirmYes")
      } else if (id == "transferConfirmYes") {
        focusElemnt("transferConfirmNo")
      }
    }
  }
  const handleKeyDownSuccess = (e, id) => {
    if (e.keyCode === 37) {
      if (id == "transferSuccessNo") {
        focusElemnt("transferSuccessYes")
      } else if (id == "transferSuccessYes") {
        focusElemnt("transferSuccessNo")
      }
    } else if (e.keyCode == 39) {
      if (id == "transferSuccessNo") {
        focusElemnt("transferSuccessYes")
      } else if (id == "transferSuccessYes") {
        focusElemnt("transferSuccessNo")
      }
    }
  }
  const CancelTransfer = () => {
    return (
      <Modal headTxt={`Cancel Transfer`} width={'95%'} updateModal={updateModal} sx={{ marginTop: '20px' }}>
        <Stack className="cancelTransferHeader">
          <Grid container sx={{ background: '#e1f2fe' }}>
            <Grid item xs={6} md={2}>
              <Item sx={{ background: '#e1f2fe' }}>
                <div className="input--container date-picker" style={{ width: '100%' }}>
                  <Datepicker
                    className="deliver-date-picker"
                    name={'filter_from_dt'}
                    type="filter_from_dt"
                    // statusChecked={true}
                    dateChange={(date) => {
                      handleChange(date, 'transferfromdate')
                    }}
                    label={Transfer_From_Date}
                    disabled={false}
                    star={true}
                  />
                </div>
              </Item>
            </Grid>
            <Grid item xs={6} md={2}>
              <Item sx={{ background: '#e1f2fe' }}>
                <div className="input--container date-picker" style={{ width: '100%' }}>
                  <Datepicker
                    className="deliver-date-picker"
                    name={'filter_from_dt'}
                    type="filter_from_dt"
                    // statusChecked={true}
                    dateChange={(date) => {
                      handleChange(date, 'transferTodate')
                    }}
                    label={Transfer_To_Date}
                    disabled={false}
                    star={true}
                  />
                </div>
              </Item>
            </Grid>
            <Grid item xs={6} md={3}>
              <Item sx={{ background: '#e1f2fe' }}>
                <DropDownOA
                  type={SOURCE_CITY_OP}
                  //  field="compulsory"
                  defaultvalue={'All'}
                  data={[cityObj, ...cityList] || []}
                  width="100%"
                  searchPlaceholder={`Search ${SOURCE_CITY_OP}`}
                  label={SOURCE_CITY_OP}
                  tabIndex="2"
                  dataKey={`CityName`}
                  idKey={`CityID`}
                  allValues={allSelectedState}
                  setAllValue={setAllSelectedState}
                />
              </Item>
            </Grid>
            <Grid item xs={6} md={3}>
              <Item sx={{ background: '#e1f2fe' }}>
                <DropDownOA
                  type={DESTOINATION_CITY_OP}
                  //  field="compulsory"
                  defaultvalue={'All'}
                  data={([cityObj, ...cityList] || [])?.filter(({ CityID }) => strtCity?.CityID != CityID)}
                  width="100%"
                  searchPlaceholder={`Search ${DESTOINATION_CITY_OP}`}
                  label={DESTOINATION_CITY_OP}
                  tabIndex="2"
                  dataKey={`CityName`}
                  idKey={`CityID`}
                  sx={{ background: 'white', color: 'white' }}
                  allValues={allSelectedState}
                  setAllValue={setAllSelectedState}
                />
              </Item>
            </Grid>
            <Grid item xs={6} md={2}>
              <Item sx={{ background: '#e1f2fe', marginLeft: '10px' }}>
                <Button
                  className="select-lr-btn3"
                  variant="contained"
                  color="error"
                  style={{ cursor: 'pointer', padding: '6px', fontSize: '15px', background: '#fe5200' }}
                  onClick={() => onClick('cancelGenerate')}
                >
                  Generate
                </Button>
              </Item>
            </Grid>
          </Grid>
        </Stack>
        <Stack sx={{ height: 450, minWidth: 700 }}>
          <TableContainer className="lr-popup-table lrModel cancelTransferTable" component={Paper}>
            <Table style={{}} className="table1 table-branch2" size="small" aria-label="a dense table">
              <TableHead style={{ position: `sticky`, top: `0`, background: `white` }}>
                <TableRow style={{ background: '#d9edff' }}>
                  <TableCell style={{ fontSize: '12px' }}>Select</TableCell>
                  <TableCell style={{ fontSize: '12px' }}>Is Received</TableCell>
                  <TableCell style={{ fontSize: '12px' }}>LR No.</TableCell>
                  <TableCell style={{ fontSize: '12px' }}>LR Date</TableCell>
                  <TableCell style={{ fontSize: '12px' }}>Transfer Date</TableCell>
                  <TableCell style={{ fontSize: '12px' }}>Sender</TableCell>
                  <TableCell style={{ fontSize: '12px' }}>Receiver</TableCell>
                  <TableCell style={{ fontSize: '12px' }}>Source City</TableCell>
                  <TableCell style={{ fontSize: '12px' }}>Transfer City</TableCell>
                  <TableCell style={{ fontSize: '12px' }}>Transfer To</TableCell>
                  <TableCell style={{ fontSize: '12px' }}>Vehicle No.</TableCell>
                  <TableCell style={{ fontSize: '12px' }}>Action</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="checkbox-ctrl"></TableCell>
                  {repeatdata.map((item, i) => (
                    <>
                      <TableCell style={{ padding: '6px' }} key={i}>
                        <div className="filter-input" style={{ fontSize: '12px' }}>
                          <input
                            className="field"
                            name="cancelSearchInput"
                            placeholder={item.name}
                            onChange={() => {
                              handleChangeContain(item.id, item.colName)
                            }}
                            style={{ width: '80px' }}
                          />
                          <FilterAltIcon />
                        </div>
                      </TableCell>
                    </>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody className="filter-data-row">
                {cancelTransferList
                  ? (searchStatus ? filtered : CancelTransferListData)?.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell className="checkbox-ctrl" style={{ paddingTop: '9px' }}>
                        <input
                          type="checkbox"
                          id={item.BookingID}
                          onChange={(e) => handleChange(e, 'cancelListData')}
                          checked={item.checked}
                        />
                      </TableCell>
                      <TableCell>
                        <span style={{ fontSize: '11px' }} title={item.IsReceived}>
                          {item.IsReceived == 0 ? 'No' : 'Yes'}
                        </span>
                      </TableCell>
                      <TableCell>
                        <span style={{ fontSize: '11px' }} title={item.IsReceived}>
                          {item.LRNO}
                        </span>
                      </TableCell>
                      <TableCell>
                        <span style={{ fontSize: '11px' }} title={item.BookingDateTime}>
                          {dateFormat(item.BookingDateTime)}
                        </span>
                      </TableCell>
                      <TableCell>
                        <span style={{ fontSize: '11px' }} title={item.TransferDateTime}>
                          {dateFormat(item.TransferDateTime)}
                        </span>
                      </TableCell>
                      <TableCell>
                        <span style={{ fontSize: '11px' }} title={item.Sender}>
                          {item.Sender}
                        </span>
                      </TableCell>
                      <TableCell>
                        <span style={{ fontSize: '11px' }} title={item.RecName}>
                          {item.RecName}
                        </span>
                      </TableCell>
                      <TableCell>
                        <span style={{ fontSize: '11px' }} title={item.FromCity}>
                          {item.FromCity}
                        </span>
                      </TableCell>
                      <TableCell>
                        <span style={{ fontSize: '11px' }} title={item.ToCity}>
                          {item.ToCity}
                        </span>
                      </TableCell>
                      <TableCell>
                        <span style={{ fontSize: '11px' }} title={item.TransferedTo}>
                          {item.TransferedTo}
                        </span>
                      </TableCell>
                      <TableCell>
                        <span style={{ fontSize: '11px' }} title={item.VehicleNo}>
                          {item.VehicleNo}
                        </span>
                      </TableCell>

                      <TableCell>
                        <span
                          style={{ display: 'flex', color: '#007bfd', fontSize: '13px', fontWeight: 'bold' }}
                          onClick={() => onClick('cancelEdit', item)}
                        >
                          <EditIcon sx={{ marginRight: '3px' }} />
                          Edit
                        </span>
                      </TableCell>
                    </TableRow>
                  ))
                  : ''}
              </TableBody>
            </Table>
            {TableListData == true ? (
              <>
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px', color: 'red' }}>
                  <span>No results found. Please refine your search parameters and search again.</span>
                </div>
              </>
            ) : TableListData == false ? (
              ''
            ) : (
              ''
            )}
          </TableContainer>
        </Stack>
        <Stack>
          <div className="modal-btn-grp">
            <Button
              className="cancel-btn"
              sx={{ marginRight: '5px' }}
              variant="outlined"
              color="error"
              onClick={() => onClick('CANCELTRANSFERCLOSE')}
            >
              Cancel
            </Button>
            <Button className="select-lr-btn4" variant="contained" onClick={() => onClick('CancelTransferPopup')}>
              Cancel Transfer
            </Button>
          </div>
        </Stack>
      </Modal>
    )
  }

  const CancelTransferModal = (isRecve = false) => {
    return (
      <Modal headTxt={`Confirm`} width={'25%'} updateModal={updateModal}>
        <Stack>
          <Box style={{ margin: '20px', fontSize: '16px' }}>
            <div>Please confirm you want to Cancel transfer of selected consignment/s</div>
          </Box>
        </Stack>
        <Stack>
          {/* background: '#f15a22' */}
          <div className="modal-btn-grp">
            <button
              autoFocus
              id="deliveryyes"
              style={{ background: '#fe5200', color: 'white', padding: '7px 20px', cursor: 'pointer', fontSize: '12px' }}
              onClick={() => onClick('cancelTransfer')}
            >
              YES
            </button>
            <Button
              className="select-lr-btn"
              variant="outlined"
              color="error"
              onClick={() => onClick('closeCancelTransfer')}
              style={{ cursor: 'pointer', fontSize: '12px' }}
            >
              NO
            </Button>
          </div>
        </Stack>
      </Modal>
    )
  }
  const CancelSuccessModal = (isRecve = false) => {
    return (
      <Modal headTxt={`Confirm`} width={'25%'} updateModal={updateModal}>
        <Stack>
          <Box style={{ margin: '10px', fontSize: '17px' }}>
            <div> Successfull Transfer Cancel of Selected LR</div>
          </Box>
        </Stack>
        <Stack>
          <div className="modal-btn-grp" style={{ marginRight: '10px' }}>
            <button
              autoFocus
              id="deliveryyes"
              style={{ background: '#fe5200', cursor: 'pointer', color: 'white', padding: '7px 20px' }}
              onClick={() => onClick('successfullTransferCancel')}
            >
              Ok
            </button>
          </div>
        </Stack>
      </Modal>
    )
  }
  //Succsess Modal
  const successTransferModal = (isRecve = false) => {
    return (
      <Modal headTxt={`Confirm`} width={'25%'} updateModal={updateModal}>
        <Stack>
          <Box style={{ margin: '20px', fontSize: '16px' }}>
            <div>
              Please confirm you want to transfer consignment/s from {strtBrnch.BranchName} to {transferToBranch.BranchName}
            </div>
          </Box>
        </Stack>
        <Stack>
          {/* background: '#f15a22' */}
          <div className="modal-btn-grp">
            <Button
              // autoFocus
              className="select-lr-btn"
              onKeyDown={(e) => handleKeyDownConfirm(e, 'transferConfirmYes')}
              id="transferConfirmYes"
              style={{ background: '#fe5200', color: 'white', padding: '7px 20px', cursor: 'pointer', fontSize: '12px' }}
              onClick={() => onClick('confirmTransfer')}
            >
              Yes
            </Button>
            <Button
              onKeyDown={(e) => handleKeyDownConfirm(e, 'transferConfirmNo')}
              id="transferConfirmNo"
              className="select-lr-btn"
              variant="outlined"
              color="error"
              onClick={() => onClick('CLosePopupTransfer')}
              style={{ cursor: 'pointer', fontSize: '12px' }}
              autoFocus={true}
            >
              No
            </Button>
          </div>
        </Stack>
      </Modal>
    )
  }

  const TransferSuccessModal = (isRecve = false) => {
    return (
      <Modal headTxt={`Success`} width={load ? '90%' : '25%'} updateModal={updateModal}>
        {load ? (
          ''
        ) : (
          <>
            <Stack>
              <Box style={{ margin: '20px', fontSize: '16px' }}>
                <div>Successfull Transfer </div>
                <div>Do you want Print ?</div>
              </Box>
            </Stack>
            <Stack>
              <div className="modal-btn-grp">
                <button
                  id="transferSuccessYes"
                  className="select-lr-btn"
                  style={{ background: '#fe5200', cursor: 'pointer', color: 'white', padding: '7px 20px', fontSize: '12px' }}
                  onClick={() => onClick('successfullTransfer')}
                  onKeyDown={(e) => handleKeyDownSuccess(e, 'transferSuccessYes')}
                >
                  YES
                </button>

                <Button
                  className="select-lr-btn"
                  autoFocus="true"
                  variant="outlined"
                  color="error"
                  id="transferSuccessNo"
                  onClick={() => onClick('successfullTransferclose')}
                  style={{ cursor: 'pointer', fontSize: '12px' }}
                  onKeyDown={(e) => handleKeyDownSuccess(e, 'transferSuccessNo')}
                >
                  No
                </Button>
              </div>
            </Stack>
          </>
        )}
        {generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
        {load ? (
          <object
            id="output2"
            type="application/pdf"
            width="1330"
            height="600"
            title="MTLPL -Cargo System - After Transfer Summary Report"
            aria-label="MTLPL -Cargo System - After Transfer Summary Report"
          ></object>
        ) : (
          ''
        )}
      </Modal>
    )
  }
  const LastTransferPrint = (isRecve = false) => {
    return (
      <Modal headTxt={` Last Transfer Print`} width={load ? '90%' : '25%'} updateModal={updateModal}>
        {load ? (
          ''
        ) : (
          <>
            <Stack>
              <Box style={{ margin: '20px', fontSize: '16px' }}>
                <div>Do you want to Last Transfer Print ?</div>
              </Box>
            </Stack>
            <Stack>
              <div className="modal-btn-grp">
                <button
                  autoFocus
                  id="deliveryyes"
                  style={{ background: '#fe5200', cursor: 'pointer', color: 'white', padding: '7px 20px', fontSize: '12px' }}
                  onClick={() => onClick('LastTransferPrint')}
                >
                  YES
                </button>

                <Button
                  className="select-lr-btn"
                  variant="outlined"
                  color="error"
                  onClick={() => onClick('LastTransferPrintClose')}
                  style={{ cursor: 'pointer', fontSize: '12px' }}
                >
                  NO
                </Button>
              </div>
            </Stack>
          </>
        )}
        {generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
        {load ? (
          <object
            id="output3"
            type="application/pdf"
            width="1330"
            height="600"
            title="MTLPL -Cargo System - After Transfer Summary Report"
            aria-label="MTLPL -Cargo System - After Transfer Summary Report"
          ></object>
        ) : (
          ''
        )}
      </Modal>
    )
  }

  const UpdateTransferModal = (isRecve = false) => {
    return (
      <Modal headTxt={`Confirm`} width={'35%'} updateModal={updateModal}>
        <Stack>
          <Box style={{ margin: '20px', fontSize: '19px' }}>
            <div>Please confirm you want to Update transfer of selected consignment/s</div>
          </Box>
        </Stack>
        <Stack>
          <div className="modal-btn-grp">
            <button
              autoFocus
              id="deliveryyes"
              style={{ background: '#fe5200', color: 'white', padding: '7px 20px', cursor: 'pointer' }}
              onClick={() => onClick('UpdateTransfer')}
            >
              Yes
            </button>
            <Button
              className="select-lr-btn"
              variant="outlined"
              color="error"
              onClick={() => onClick('closeUpdateTransfer')}
              style={{ cursor: 'pointer' }}
            >
              No
            </Button>
          </div>
        </Stack>
      </Modal>
    )
  }
  const UpdateTransferSuccessModal = (isRecve = false) => {
    return (
      <Modal headTxt={`Confirm`} width={'25%'} updateModal={updateModal}>
        <Stack>
          <Box style={{ margin: '10px', fontSize: '17px' }}>
            <div> Successfull Transfer Update of Selected LRNO:{cancelEditLrNo}</div>
          </Box>
        </Stack>
        <Stack>
          <div className="modal-btn-grp" style={{ marginRight: '10px' }}>
            <button
              autoFocus
              id="deliveryyes"
              style={{ background: '#fe5200', cursor: 'pointer', color: 'white', padding: '7px 20px' }}
              onClick={() => onClick('successfullTransferUpdate')}
            >
              Ok
            </button>
          </div>
        </Stack>
      </Modal>
    )
  }
  //for print memo enter chaallan no

  const printMemoModal = (isRecve = false) => {
    return (
      <Modal headTxt={printMemo.status === 'Success' ? `Branch Transfer Print Memo` : `Enter Challan Number`} width={load ? '90%' : '25%'} updateModal={updateModal}>
        <>
          {load ? (
            // <button autoFocus={true} onClick={()=>printClick()} style={{ visibility: 'hidden' }}>Print</button>
            ''
          ) : (
            <>
              <Stack>
                <Box sx={{ width: '100%', display: 'inline-flex', padding: '0% 0px' }}>
                  <div className={'input--wrapper'} style={{ width: '100%', marginLeft: '12px', marginRight: '8px', marginTop: '15px' }}>
                    <LineInput
                      id={`Enter_CHALLAN_NO`}
                      label={`Enter Challan Number`}
                      width="11%"
                      type="number"
                      name="Enter_CHALLAN_NO"
                      value={challanNumber}
                      onChange={(e) => handleChange(e, 'challanNO')}
                      lg={{ margin: '8px', width: '100%' }}
                    />
                  </div>
                </Box>
              </Stack>
              <Stack>
                <div>
                  <Box style={{ margin: '15px 0px', marginLeft: '12px', marginRight: '8px' }}>
                    <Button
                      variant="contained"
                      style={{ backgroundColor: '#fe5200', width: '100%', padding: '10px', fontSize: '13px' }}
                      onClick={() => onClick('printMemo')}
                    >
                      Print Memo
                    </Button>
                  </Box>
                </div>
              </Stack>
            </>
          )}
          {generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
          {load ? (
            <object
              id="output"
              type="application/pdf"
              width="1330"
              height="600"
              title="MTLPL - Maintenance System - Closing Stock Summary Report"
              aria-label="MTLPL - Maintenance System - Closing Stock Summary Report"
            ></object>
          ) : (
            ''
          )}
        </>
      </Modal>
    )
  }
  const onSaveColumns = (item) => {
    setManageColumn(item)
    localStorage.setItem('BrnhTransferMemoManageCol1', JSON.stringify(item))
  }
  return (
    <>
      <div className="bottom-section">
        <Stack
          direction="row"
          divider={
            <Divider
              orientation="vertical"
              sx={{
                width: '2px',
                margin: '0px -16px 0px 0px !important',
                //   backgroundColor: "#0086ff",
                backgroundColor: '#DDD',
              }}
              flexItem
            />
          }
          spacing={2}
          sx={{ background: '#f0fcf4' }}
          className={` beachTransBottomSec`}
        >
          <Item sx={{ width: '100%', paddingTop: '16px', background: '#f0fcf4' }}>
            <Box
              sx={{
                flexGrow: 1,
                width: '100%',
                display: 'inline-flex',
                padding: '0% 10px',
                background: '#f0fcf4',
              }}
            >
              <Item sx={{ width: '50%', background: '#f0fcf4', color: '#f0fcf4',marginBottom:'15px' }}>
                <DropDownOA
                  id="TrToBranch"
                  // nextId="TransferReason"
                  nextId={[STA_COMPANY_ID,RAJESH_TRANSPORT].includes(loginData.intCompanyID)?"selectTV":'checkbox_0'}
                  prevId="checkbox_0"
                  // lrData={lrData}
                  type={Transfer_To_Branch}
                  //  field="compulsory"
                  label={Transfer_To_Branch}
                  defaultvalue={defaultValue == true ? ' ' : ''}
                  data={TransferBranchList || []}
                  dataKey={`BranchName`}
                  idKey={`BranchName`}
                  width="100%"
                  searchPlaceholder={`Search ${Transfer_To_Branch}`}
                  allValues={allSelectedState}
                  setAllValue={setAllSelectedState}
                />
              </Item>
              {
                [STA_COMPANY_ID,RAJESH_TRANSPORT].includes(loginData.intCompanyID) === false &&
                <Item sx={{ width: '50%', background: '#f0fcf4' }}>
                  <div className={'input--wrapper'}>
                    <LineInput
                      id="TransferReason"
                      type="text"
                      name={'TransferReason'}
                      label={
                        <>
                          {loginData?.intCompanyID === STA_COMPANY_ID ? (
                            <>
                              Transfer Reason<span style={{ color: 'red' }}>*</span>
                            </>
                          ) : (
                            'Transfer Reason'
                          )}
                        </>
                      }
                      value={transferReason}
                      // icon={'chkActionGST'}
                      onKeyDown={(e) => onKeyDown('TransferReason', e)}
                      onChange={(e) => handleChange(e, 'TransferReason')}
                    // disabled={true}
                    />
                  </div>
                </Item>
              }
            </Box>

            <Box
              sx={{
                flexGrow: 1,
                width: '100%',
                display: 'inline-flex',
                padding: '0% 10px',
                background: '#f0fcf4',
              }}
            >
              <Item sx={{ width: '25%', background: '#f0fcf4' }}>
                <div className={'input--wrapper'}>
                  <LineInput
                    id="remarks"
                    type="text"
                    name={'SenGstnNo'}
                    label={`Remarks`}
                    value={remarks}
                    // onKeyDown={(e) => onKeyDown('remarks', e)}
                    onKeyDown={(e) => navigation3(e, 'Transferbtn', "selectDN", () => { })}
                    onChange={(e) => handleChange(e, 'remark')}
                  // disabled={true}
                  />
                </div>
              </Item>

              <Item sx={{ width: '25%', background: '#f0fcf4' }}>
                <div className="input--container date-picker" style={{ width: '100%' }}>
                  <Datepicker
                    className="deliver-date-picker"
                    name={'filter_from_dt'}
                    type="filter_from_dt"
                    statusChecked={true}
                    label={Transfer_Date}
                    disabled
                  />
                </div>
              </Item>
              <Item sx={{ width: '25%', background: '#f0fcf4' }}>
                <div className={'input--wrapper'} style={{ width: '100%' }}>
                  <Button
                    id="manageColumn"
                    variant="outlined"
                    sx={{ width: '100%' }}
                    style={{
                      borderColor: '#f15a22',
                      color: '#f15a22',
                      fontSize: '14px',
                      fontWeight: 'bold',
                      textTransform: 'Uppercase',
                      padding: '5px 8px',
                      display: 'flex',
                      alignItems: 'center'
                    }}
                    onClick={() => updateModal(true, mdt.BrnhTransferMemoManageCol)}
                  >
                    <span tabIndex={0} style={{ fontWeight: '600' }}>
                      MANAGE COLUMNS
                    </span>
                  </Button>
                </div>
              </Item>
              <Item sx={{ width: '25%', background: '#f0fcf4' }}>
                <div className={'input--wrapper'} style={{ width: '100%' }}>
                  <Button
                    variant="outlined"
                    sx={{ width: '100%' }}
                    style={{ borderColor: '#fe5200', color: '#fe5200', fontSize: '15px', fontWeight: 'bold', textTransform: 'Uppercase' }}
                    onClick={() => onClick('printMemoPopUp')}
                    disabled={cancelEdit == true ? true : false}
                  >
                    {' '}
                    Print Memo
                  </Button>
                </div>
              </Item>
            </Box>
          </Item>
          <Item sx={{ width: '100%', paddingTop: '16px', background: '#f0fcf4' }}>
            <Box
              sx={{
                flexGrow: 1,
                width: '100%',
                display: 'inline-flex',
                padding: '0% 10px',
                background: '#f0fcf4',
              }}
            >
              <Item sx={{ width: '33%', background: '#f0fcf4' }}>
                <DropDownOA
                  id="selectTV"
                  nextId="selectDN"
                  prevId={[STA_COMPANY_ID,RAJESH_TRANSPORT].includes(loginData.intCompanyID)?"TrToBranch":'TransferReason'}
                  // lrData={lrData}
                  type={Transfer_By_Vehicle}
                  //  field="compulsory"
                  label={Transfer_By_Vehicle}
                  // defaultvalue={''}
                  resetFlag={resetFlag}
                  value={defaultValue == true ? ' ' : ''}
                  defaultvalue={defaultValue == true ? ' ' : ''}
                  data={vehicleList || []}
                  dataKey={`VehicleNo`}
                  idKey={`VehicleNo`}
                  width="100%"
                  searchPlaceholder={`Search ${Transfer_By_Vehicle}`}
                  allValues={allSelectedState}
                  setAllValue={setAllSelectedState}
                  onSelResetVal={true}
                  onReset={()=>{setAllSelectedState((prev)=>({...prev,transferByVehicle:''}))}}
                />
              </Item>
              <Item sx={{ width: '33%', background: '#f0fcf4' }}>
                <DropDownOA
                  key={`select_consigner`}
                  type={Driver_Name}
                  label={'Select Driver Name'}
                  data={driverInfo || []}
                  width="100%"
                  searchPlaceholder={'Search Driver Name'}
                  isObjArr={true}
                  dataKey={`DriverConductorName`}
                  idKey={`DriverConductorID`}
                  id="selectDN"
                  nextId="remarks"
                  prevId="selectTV"
                  allValues={allSelectedState}
                  setAllValue={setAllSelectedState}
                  defaultvalue={defaultValue == true ? ' ' : ''}
                />
              </Item>
              <Item sx={{ width: '33%', background: '#f0fcf4' }}>
                <div className={'input--wrapper'}>
                  <LineInput
                    type="text"
                    name={'SenGstnNo'}
                    label={`Driver No.`}
                    // defaultvalue={"Driver No."}
                    value={defaultValue == true ? '' : selectedDriver?.ContactNo}
                    disabled={true}
                  />
                </div>
              </Item>
            </Box>

            <Box
              sx={{
                flexGrow: 1,
                width: '100%',
                display: 'flex',
                padding: '0% 10px',
                // marginTop: "15px",
                background: '#f0fcf4',
              }}
            >
              <Item sx={{ width: '100%', background: '#f0fcf4' }}>
                <Button
                  variant="outlined"
                  sx={{ width: '100%' }}
                  style={{ borderColor: '#fe5200', color: '#f15a22', fontSize: '15px', fontWeight: 'bold', textTransform: 'Uppercase' }}
                  onClick={() => onClick('LastTransferPrintBTN')}
                  disabled={cancelEdit == true ? true : false}
                >
                  {' '}
                  Last Transfer Print
                </Button>
              </Item>
              <Item sx={{ width: '100%', background: '#f0fcf4' }}>
                <Button
                  variant="outlined"
                  sx={{ width: '100%' }}
                  style={{ borderColor: '#fe5200', color: '#f15a22', fontSize: '15px', fontWeight: 'bold', textTransform: 'Uppercase' }}
                  onClick={() => onClick('CANCELTRANSFER')}
                  disabled={cancelEdit == true ? true : false}
                >
                  {' '}
                  Cancel Transfer
                </Button>
              </Item>
              {cancelEdit == true ? (
                <Item sx={{ width: '100%', background: '#f0fcf4' }}>
                  <Button
                    variant="contained"
                    id="Transferbtn"
                    sx={{ width: '100%' }}
                    style={{ backgroundColor: '#fe5200', fontSize: '15px', textTransform: 'Uppercase', color: '#fff', fontWeight: 'bold' }}
                    onKeyDown={(e) => onKeyDown('Transferbtn', e)}
                    onClick={() => onClick('UpdateTransferModal')}
                  >
                    {' '}
                    Update
                  </Button>
                </Item>
              ) : (
                <Item sx={{ width: '100%', background: '#f0fcf4' }} onKeyDown={(e) => navigation3(e, 'selectDC', "remarks", () => { })} onClick={() => onClick('Transfer')}>
                  <Button
                    variant="contained"
                    id="Transferbtn"
                    sx={{ width: '100%' }}
                    style={{ backgroundColor: '#fe5200', fontSize: '15px', textTransform: 'Uppercase', color: '#fff', fontWeight: 'bold' }}


                  >
                    {' '}
                    Transfer
                  </Button>
                </Item>
              )}
            </Box>
          </Item>
        </Stack>
      </div>
      {showModal && [successModal.CANCELTRANSFER.id].includes(modalType) && CancelTransfer(modalType == successModal.CANCELTRANSFER.id)}
      {showModal && [successModal.SuccessTransfer.id].includes(modalType) && successTransferModal(successModal.SuccessTransfer.id)}
      {showModal &&
        [successModal.SuccessTransferMessage.id].includes(modalType) &&
        TransferSuccessModal(successModal.SuccessTransferMessage.id)}
      {showModal &&
        [successModal.CancelTransferMessage.id].includes(modalType) &&
        CancelTransferModal(successModal.CancelTransferMessage.id)}
      {showModal &&
        [successModal.SuccessCancelTransferMessage.id].includes(modalType) &&
        CancelSuccessModal(successModal.SuccessCancelTransferMessage.id)}
      {showModal && [successModal.PrintMemo.id].includes(modalType) && printMemoModal(successModal.PrintMemo.id)}
      {showModal && [successModal.LastTransferPrint.id].includes(modalType) && LastTransferPrint(successModal.LastTransferPrint.id)}
      {showModal && [successModal.UpdatePopUp.id].includes(modalType) && UpdateTransferModal(successModal.UpdatePopUp.id)}
      {showModal &&
        [successModal.SuccessUpdatePopUp.id].includes(modalType) &&
        UpdateTransferSuccessModal(successModal.SuccessUpdatePopUp.id)}
      {showModal && mdt.BrnhTransferMemoManageCol === modalType ? <ManageColumns headers={manageColumn} onSave={onSaveColumns} updateModal={updateModal} /> : null}

    </>
  )
}

const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = {
  updateModal,
  getVehicleList,
  updateAlert,
  getBranchTransfer,
  getCancelTransferList,
  getCancelTransfer,
  getPrintMemo,
  getUpdateTransfer,
  getUpdateGetChallanNum,
  getBranchTransferV2,
}

export default connect(mapStateToProps, mapDispatchToProps)(BottomSection)
